import styled from '@emotion/styled';
import { sizes } from 'config/variables';
import { toPx } from 'utils/styles';

export const TextStyled = styled('p')({
  color: 'inherit',
  fontWeight: 'inherit',
  margin: `0 0 ${toPx(sizes.spacing * 3)}`,
});
